




import { Component, Vue } from 'vue-property-decorator';
import PaymentMethodList from '@/components/PaymentMethod/PaymentMethodList.vue';

@Component({
  components: {
    PaymentMethodList,
  },
})
export default class PaymentMethods extends Vue {
}
